var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MacBook Pro 14\" - 74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5984,
    transform: "translate(-1369 -1103)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707480173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707480156",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 590,
    transform: "translate(-1369 -458)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75323 4.06976L8.71231 9.05899L3.75323 14.0181H0V18.0878H5.44143L14.4853 9.05899L5.44143 0H0V4.06976H3.75323Z",
    fill: "#0646A7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 590,
    fill: "white",
    transform: "translate(-1369 -458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterT);
export default __webpack_public_path__ + "static/media/greaterT.e78ae6e2408730fa4f55271e65628306.svg";
export { ForwardRef as ReactComponent };